module.exports = __webpack_public_path__ + "img/黎明化工研究院.93b798f1.jpg";